import Component from '../core/Component'
import { queryAll } from '../utils/dom'

export const STATUS = {
    ACTIVE: 'is-active'
}

export default class Gallery extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            image: null,
            thumbnails: [],
            toolbar: null,
            toolbarContent: null,
            buttonPrev: null,
            buttonNext: null
        }

    }
    prepare() {
        this.ref.thumbnails.forEach(element => {
            element.addEventListener('click', ::this.handleClick)
        })

        this.ref.buttonPrev.addEventListener('click', ::this.handlePrevClick)
        this.ref.buttonNext.addEventListener('click', ::this.handleNextClick)

        this.check()
    }

    handleClick(event) {
        event.preventDefault()

        const item = event.currentTarget
        this.ref.image.src = item.href
        this.ref.image.width = item.dataset.width
        this.ref.image.height = item.dataset.height

        this.ref.thumbnails.forEach(element => element.classList.remove(STATUS.ACTIVE))
        item.classList.add(STATUS.ACTIVE)
    }

    handlePrevClick(event) {
        event.preventDefault()
        this.scroll(-1)
    }

    handleNextClick(event) {
        event.preventDefault()
        this.scroll(1)
    }

    scroll(direction = 1) {
        const width = this.ref.toolbarContent.offsetWidth
        const scrollWidth = this.ref.toolbarContent.scrollWidth
        const offset = this.ref.toolbarContent.scrollLeft

        const target = Math.min(offset + width * direction, scrollWidth - width)

        this.ref.toolbarContent.scrollLeft = target

        this.check()
    }

    check() {
        this.ref.buttonPrev.disabled = this.ref.toolbarContent.scrollLeft === 0
        this.ref.buttonNext.disabled = this.ref.toolbarContent.scrollLeft + this.ref.toolbarContent.offsetWidth === this.ref.toolbarContent.scrollWidth
    }

}